// extracted by mini-css-extract-plugin
var _1 = "AttachServiceRequestsModalAISuggestionsPanel-modulebuttons__jXJ6D";
var _2 = "AttachServiceRequestsModalAISuggestionsPanel-modulecollapseButton__CGoH3 AIButtonIconFlat-moduleaiButtonIconFlat__x_yP1 AIButtonIcon-moduleaiButtonIcon__WNIqX";
var _3 = "AttachServiceRequestsModalAISuggestionsPanel-moduleheader__kzxks";
var _4 = "AttachServiceRequestsModalAISuggestionsPanel-modulepanel__e_3vK";
var _5 = "AttachServiceRequestsModalAISuggestionsPanel-modulerows__cqk9T";
var _6 = "AttachServiceRequestsModalAISuggestionsPanel-moduletitle__v_8pl";
export { _1 as "buttons", _2 as "collapseButton", _3 as "header", _4 as "panel", _5 as "rows", _6 as "title" }
